import { STATUS } from "../../../../constants";

const { LOADING } = STATUS;

export const isPhoneInputDisabled = (status) => status === LOADING;
